import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import styled from 'foundations-theming/utils';
import { trellisBreakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { useMedia } from 'pricing-pages-ui-components/hooks/useMedia';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import PhoneSupport from 'pricing-pages-ui/components/common/PhoneSupport';
import { useAppSelector } from '../../reducers';
import { isUngatedForInbound25Selector } from '../../selectors/GatingSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledHeading = styled.h2.withConfig({
  displayName: "PhoneSupportFooter__StyledHeading",
  componentId: "i9y3nz-0"
})(({
  theme
}) => {
  return Object.assign({}, theme.typography['heading-600'], {
    inlineSize: '70%',
    [trellisBreakpoint.tablet]: Object.assign({
      textAlign: 'center',
      inlineSize: 'auto'
    }, theme.typography['heading-300']),
    [trellisBreakpoint.phone]: Object.assign({}, theme.typography['heading-200'])
  });
});
function PhoneSupportFooter({
  phoneSourceId,
  screen,
  upgradeProduct
}) {
  const isUngatedForInbound = useAppSelector(isUngatedForInbound25Selector);
  const isTabletOrSmaller = useMedia('tablet');
  if (isUngatedForInbound) {
    return /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsxs(Flex, {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        flexDirection: isTabletOrSmaller ? 'column' : 'row',
        justifyContent: isTabletOrSmaller ? 'center' : 'space-between',
        children: [/*#__PURE__*/_jsx(View, {
          maxInlineSize: "600px",
          inlineSize: isTabletOrSmaller ? '100%' : '70%',
          textAlign: isTabletOrSmaller ? 'center' : 'left',
          children: /*#__PURE__*/_jsx(Text, {
            as: "h2",
            "data-selenium-id": "phone-support-footer-header",
            typography: "heading-400",
            textWrap: "wrap",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricingPage.pages.crm.stillHaveQuestions"
            })
          })
        }), /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          display: "inline-flex",
          children: /*#__PURE__*/_jsx(PhoneSupport, {
            screen: screen,
            phoneSourceId: phoneSourceId,
            showCopy: false,
            showBorder: false,
            upgradeProduct: upgradeProduct
          })
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsxs(Flex, {
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      children: [/*#__PURE__*/_jsx(StyledHeading, {
        "data-selenium-id": "phone-support-footer-header",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.crm.stillHaveQuestions"
        })
      }), /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        display: "inline-flex",
        children: /*#__PURE__*/_jsx(PhoneSupport, {
          screen: screen,
          phoneSourceId: phoneSourceId,
          showCopy: false,
          showBorder: false,
          upgradeProduct: upgradeProduct
        })
      })]
    })
  });
}
export default PhoneSupportFooter;